export default __webpack_public_path__ + "static/georges-93e4f04f72385e5fe068fd14a31beb98.jpg";